export const flexiHeader = function (el) {
    const iW = window.innerWidth;
    const iH = window.innerHeight;
    let cL;
    let cT;
    let percentageOfWindowX;
    let percentageOfWindowY;
    const blockWidth = 50;

    setTimeout(function () {
        el.querySelectorAll(".header__block--left").forEach(function (item) {
            item.style.width = blockWidth + "%";
        });
        el.querySelectorAll(".header__block--right").forEach(function (item) {
            item.style.width = 100 - blockWidth + "%";
        });
    }, 0);

    /*window.addEventListener("mousemove", function (e) {
        cL = e.clientX;
        cT = e.clientY;
        moveHeader(cL, cT);
    });

    function moveHeader(x, y) {
        percentageOfWindowX = x / iW;
        percentageOfWindowY = y / iH;

        const blockWidth = percentageOfWindowX.map(0, 1, 40, 60);
        el.querySelectorAll(".header__block--left").forEach(function (item) {
            item.style.width = blockWidth + "%";
        });
        el.querySelectorAll(".header__block--right").forEach(function (item) {
            item.style.width = 100 - blockWidth + "%";
        });
        const blockHeight = percentageOfWindowY.map(0, 1, 40, 60);
        const rows = el.querySelectorAll(".header__row");
        rows[0].style.height = blockHeight + "%";
        rows[1].style.height = 100 - blockHeight + "%";
    }*/
};
